import React, { PureComponent } from 'react';

import { getGradient, getTextColor } from '../utils/color';

import Tooltip from './tooltip';

import IconEdit from '../icons/icon-edit';
import IconCheck from '../icons/icon-check';

export default class ColorBlock extends PureComponent { 
    handleClick = () => {
        this.props.onClick && this.props.onClick(this.props.id || this.props.color);
    }

    handleEditClick = () => {
        this.props.onEditClick && this.props.onEditClick(this.props.id);
    }

    render() {
        const className = ['color-block'];
        const backgroundImage = getGradient(this.props.color);
        const color = getTextColor(this.props.color);

        if (this.props.id) className.push('editable');
        if (this.props.indicator) className.push('indicator');
        if (this.props.selected) className.push('selected');

        const inner = (
            <div
                className="color-block-inner"
                style={{ backgroundImage, color }}
            >
                {
                    this.props.name ? (
                        <span className="name">
                            { this.props.name }
                        </span>
                    ) : null
                }

                <span className="selected-icon">
                    <IconCheck />
                </span>

                <span className="color-block-click-overlay" onClick={this.handleClick} />
            </div>
        );

        return (
            <div
                className={className.join(' ')}
            >
                {
                    this.props.indicator && this.props.name ? (
                        <Tooltip tooltip={this.props.name}>{inner}</Tooltip>
                    ) : inner
                }

                {
                    !this.props.indicator && this.props.id && this.props.onEditClick ? (
                        <span className="edit-icon" onClick={this.handleEditClick}>
                            <IconEdit />
                        </span>
                    ) : null
                }
            </div>
        )
    }
}
